export default "__VITE_ASSET__ClBEgDaR__"